<template>
  <div class="attendance-warn-config-page">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.configName" placeholder="请输入配置名称" @keydown.enter="resetSearch">
            <template #prefix>配置名称</template>
          </el-input>
          <el-select v-model="searchInfo.configType" placeholder="预警类型" clearable>
            <template #prefix>预警类型</template>
            <el-option label="未打卡预警" value="MISSED_CHECKIN"></el-option>
            <el-option label="未下班打卡" value="MISSED_CHECKOUT"></el-option>
            <el-option label="迟到预警" value="LATE_CHECKIN"></el-option>
            <el-option label="早退预警" value="EARLY_CHECKOUT"></el-option>
          </el-select>
          <el-select v-model="searchInfo.isEnabled" placeholder="启用状态" clearable>
            <template #prefix>启用状态</template>
            <el-option label="全部" value=""></el-option>
            <el-option label="启用" value="Y"></el-option>
            <el-option label="禁用" value="N"></el-option>
          </el-select>
          <el-select v-model="searchInfo.attendanceType" placeholder="打卡类型" clearable>
            <template #prefix>打卡类型</template>
            <el-option v-for="item in configTypeOptions" :key="item.dictCode" :label="item.dictName" :value="item.dictCode" />
          </el-select>
        </template>
        <template #option>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
          <page-button el-type="success" @click="toAdd">新建</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border>
          <yq-table-column label="配置名称" prop="configName" min-width="130"/>
          <yq-table-column label="预警类型" prop="configType" width="140">
            <template v-slot="{row}">
              <el-tag :type="getConfigTypeTag(row.configType)">
                {{ getConfigTypeText(row.configType) }}
              </el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="打卡类型" prop="configType" width="140">
            <template v-slot="{row}">
              <c-custom-select value="dictCode" label="dictName" :data-list="configTypeOptions" v-model="row.attendanceType" read-only />
            </template>
          </yq-table-column>
          <yq-table-column label="预警条件" prop="warnCondition" width="140">
            <template v-slot="{row}">
              {{ getWarnConditionText(row.warnCondition) }}
            </template>
          </yq-table-column>
          <yq-table-column label="阈值(分钟)" prop="thresholdValue" width="140">
            <template v-slot="{row}">
              <span v-if="row.configType === 'MISSED_CHECKIN' || row.configType === 'MISSED_CHECKOUT'">
                /
              </span>
              <span v-else>
                {{ row.thresholdValue }}
              </span>

            </template>
          </yq-table-column>
          <yq-table-column label="检查间隔(分钟)" prop="checkInterval" width="140"/>
          <yq-table-column label="启用状态" prop="isEnabled" width="100">
            <template v-slot="{row}">
              <el-tag :type="row.isEnabled === 'Y' ? 'success' : 'info'">
                {{ row.isEnabled === 'Y' ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="最后检查时间" prop="lastCheckTime" width="180"/>
          <yq-table-column label="操作" prop="options" align="center" fixed="right" width="200">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button el-type="primary" @click="toEdit(row.id)">编辑</table-button>
                <table-button 
                  :el-type="row.isEnabled === 'Y' ? 'warning' : 'success'"
                  @click="toggleEnable(row)">
                  {{ row.isEnabled === 'Y' ? '禁用' : '启用' }}
                </table-button>
                <table-button el-type="danger" message="是否确认删除数据" @click="deleteRow(row.id)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page 
        v-model:page-number="searchInfo.pageNumber" 
        v-model:page-size="searchInfo.pageSize" 
        :total-count="searchInfo.totalCount" 
        @onLoad="queryList"
      />
    </list-page>

    <!-- 编辑对话框 -->
    <el-dialog 
      v-model="showDetail" 
      :title="currentData.id ? '编辑预警配置' : '新建预警配置'" 
      width="800px"
      @close="resetForm"
    >
      <form-items :data="currentData" :columns="1" label-width="140px">
        <form-item label="配置名称" name="configName" :required="true" error-message="请输入配置名称">
          <el-input v-model="currentData.configName" placeholder="请输入配置名称"/>
        </form-item>

        <form-item label="预警类型" name="configType" :required="true" error-message="请选择预警类型">
          <el-select v-model="currentData.configType" placeholder="请选择预警类型" @change="handleConfigTypeChange">
            <el-option label="未打卡预警" value="MISSED_CHECKIN"></el-option>
            <el-option label="未下班打卡" value="MISSED_CHECKOUT"></el-option>
            <el-option label="迟到预警" value="LATE_CHECKIN"></el-option>
            <el-option label="早退预警" value="EARLY_CHECKOUT"></el-option>
          </el-select>
        </form-item>

        <form-item label="打卡类型" name="attendanceType" :required="true" error-message="请选择考勤类型">
          <c-custom-select value="dictCode" label="dictName" :data-list="configTypeOptions" v-model="currentData.attendanceType" />
        </form-item>

        <form-item label="预警条件" name="warnCondition" :required="true" error-message="请选择预警条件">
          <el-select v-model="currentData.warnCondition" placeholder="请选择预警条件">
            <el-option 
              v-for="item in getConditionOptions(currentData.configType)"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </form-item>

        <form-item 
          label="阈值(分钟)" 
          name="thresholdValue" 
          :required="shouldRequireThreshold(currentData.configType)"
          error-message="请输入阈值">
          <el-input-number 
            v-model="currentData.thresholdValue" 
            :min="0" 
            :max="1440"
            :disabled="!shouldRequireThreshold(currentData.configType)"
            placeholder="请输入阈值(分钟)"/>
          <span style="margin-left: 10px; color: #999;">
            分钟（如：30表示迟到超过30分钟）
          </span>
        </form-item>

        <form-item 
          label="检查间隔(分钟)" 
          name="checkInterval" 
          :required="true"
          error-message="请输入检查间隔，最低60分钟">
          <el-input-number 
            v-model="currentData.checkInterval" 
            :min="60" 
            :max="10080"
            :step="60"
            placeholder="请输入检查间隔（分钟）"/>
          <span style="margin-left: 10px; color: #999;">
            分钟（最低60分钟）
          </span>
        </form-item>

        <form-item label="备注" name="remark">
          <el-input v-model="currentData.remark" type="textarea" :rows="3" placeholder="请输入备注"/>
        </form-item>
      </form-items>

      <template #footer>
        <page-button @click="showDetail = false">取消</page-button>
        <page-button el-type="primary" @click="save">保存</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import attendanceWarnConfigApi from "@/api/dz-luqiao/attendanceWarnConfigApi";
import commonApi from "@/api/commonApi";
import util from "@/util/util";
import CCustomSelect from "@/views/h5/luqiao/display/c-custom-select.vue";

export default {
  name: "AttendanceWarnConfig",
  components: {
    CCustomSelect,
    YqTableColumn, 
    TableButtonGroup, 
    TableButton, 
    SearchCondition, 
    FormPage, 
    ListTable, 
    ListPage, 
    FormItems, 
    FormItem
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      showDetail: false,
      currentData: {
        isEnabled: 'Y'
      },
      configTypeOptions: [],
    };
  },
  async created() {
      this.resetSearch();
      this.configTypeOptions = await commonApi.queryDictionaryList("CLOCK_DEVICE", (await util.getUserInfo()).merchantId)
  },
  methods: {
    async queryList() {
      const {records, totalCount} = await attendanceWarnConfigApi.list(this.searchInfo);
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toAdd() {
      this.showDetail = true;
      this.currentData = {
        isEnabled: 'Y',
        checkInterval: 60
      };
    },
    async toEdit(id) {
      this.currentData = await attendanceWarnConfigApi.getById(id);
      this.showDetail = true;
    },
    async save() {
      await attendanceWarnConfigApi.saveSubmit(this.currentData);
      this.resetSearch();
      this.showDetail = false;
    },
    async deleteRow(id) {
      await attendanceWarnConfigApi.delete(id);
      this.resetSearch();
    },
    async toggleEnable(row) {
      const isEnabled = row.isEnabled === 'Y' ? 'N' : 'Y';
      await attendanceWarnConfigApi.toggleEnable(row.id, isEnabled);
      this.resetSearch();
    },
    resetForm() {
      this.currentData = {};
    },
    getConfigTypeText(type) {
      const types = {
        'MISSED_CHECKIN': '未打卡预警',
        'MISSED_CHECKOUT': '未下班打卡',
        'LATE_CHECKIN': '迟到预警',
        'EARLY_CHECKOUT': '早退预警'
      };
      return types[type] || type;
    },
    getConfigTypeTag(type) {
      const tags = {
        'MISSED_CHECKIN': 'danger',
        'MISSED_CHECKOUT': 'warning',
        'LATE_CHECKIN': 'warning',
        'EARLY_CHECKOUT': 'info'
      };
      return tags[type] || '';
    },
    getWarnConditionText(condition) {
      const conditions = {
        'EXISTS': '存在',
        'GT': '大于',
        'LT': '小于',
        'GTE': '大于等于',
        'LTE': '小于等于',
        'EQ': '等于'
      };
      return conditions[condition] || condition;
    },
    getConditionOptions(configType) {
      if (configType === 'MISSED_CHECKIN' || configType === 'MISSED_CHECKOUT') {
        return [
          { label: '存在', value: 'EXISTS' }
        ];
      } else if (configType === 'LATE_CHECKIN') {
        return [
          { label: '大于', value: 'GT' }
        ];
      } else if (configType === 'EARLY_CHECKOUT') {
        return [
          { label: '小于', value: 'LT' }
        ];
      }
      return [];
    },
    shouldRequireThreshold(configType) {
      // 未打卡类型不需要阈值
      return configType !== 'MISSED_CHECKIN' && configType !== 'MISSED_CHECKOUT';
    },
    handleConfigTypeChange() {
      // 切换类型时，清空条件并设置默认值
      this.currentData.warnCondition = '';
      this.currentData.thresholdValue = null;
      
      if (this.currentData.configType === 'MISSED_CHECKIN' || this.currentData.configType === 'MISSED_CHECKOUT') {
        this.currentData.warnCondition = 'EXISTS';
        this.currentData.thresholdValue = 0;
      } else if (this.currentData.configType === 'LATE_CHECKIN') {
        this.currentData.warnCondition = 'GT';
        this.currentData.thresholdValue = 30;
      } else if (this.currentData.configType === 'EARLY_CHECKOUT') {
        this.currentData.warnCondition = 'LT';
        this.currentData.thresholdValue = 30;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

